var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-page-title"},[_c('div',{staticClass:"content"},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$app.router.current().title))]),_c('n-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }